export default function BuySell() {
    return (
      <section>
       
      </section>
    );
  }